import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { ClientUserData } from "@/common/types/client/clientUserData.type"
import { User2Icon } from "lucide-react";

type BuyerEventableProps = {
  data: ClientUserData
}

const EstablishmentConsumptionBuyer = ({data: buyer}: BuyerEventableProps) => {
  return (
    <div className="flex gap-2 items-center">
      <ImageWithDisplayName
        placeholderIcon={User2Icon}
        imageUrl={buyer?.profile_picture?.url}
        displayName={buyer?.full_name}
      />
  </div>
  )
}

export default EstablishmentConsumptionBuyer
